module.exports = __webpack_public_path__ + "static/media/medpharm_requirements.3aded299.png";